<template>
  <v-container class="container" >
    <v-row>
      <v-col>
        <v-btn variant="elevated" color="primary" @click="goToCreateUser()">
          Crear Usuario
        </v-btn>
      </v-col>
    </v-row>
    <v-card class="mt-5">
      <v-container>
        <div>
          <v-data-table
            :headers="headers"
            :items="usuarios"
            :items-per-page="5"
            class="caption"
          >
            <template v-slot:[`item.verdetalle`]="{ item }">
              <div class="d-flex">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="black"
                      style="font-size: 35px;"
                      @click="gotToEditUser(item.id)"
                      class="mr-2"
                      v-bind="attrs"
                      v-on="on"
                      >mdi-card-search-outline</v-icon
                    >
                  </template>
                  <span>Ver Detalle</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </div>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";
import {UserService} from "../../util/Api/Usuarios/calls"
import { Loading } from "element-ui"
export default {
  name: "ListarUsuariosComponents",
  components: {
},
  data() {
    return {
      status: false,
      showDialog: false,
      menuFechaCarga: false,
      fechaCarga: null,
      headers: [
        { text: "ID", value: "id" },
        { text: "RUN", value: "run" },
        { text: "NOMBRES", value: "nombres" },
        { text: "APELLIDOS", value: "apellidos" },
        { text: "SUBDIRECCION", value: "subdireccion" },
        { text: "direccion regional", value: "direccion_regional" },
        { text: "ESTADO", value: "estado" },
        { text: "VER DETALLE", value: "verdetalle" },

      ],
      usuarios:[],
    };
  },
  async created(){
    let loadingInstance =  Loading.service({ fullscreen: true, text: 'Cargando..', background: 'rgba(0, 0, 0, 0.8)' }) 
   this.usuarios = await this.getUsuarios()
         loadingInstance.close() 
   
  },
  methods: {
    ...mapMutations("editUsuario", ["setDetalle"]),
    openDialog(data) {
    console.log(data);
      this.setDetalle(data);
      this.showDialog = true;
    },

    goToCreateUser() {
      this.$router.push({ name: "crearUsuario" });
    },
    gotToEditUser(id) {
      this.$router.push({ name: "editarusuario", params: { id: id } });
    },
    async removeUser(id) {
      const confirm = await this.$root.$confirm(
        "Eliminar concepto",
        "¿Está seguro de eliminar el concepto?"
      );

      if (confirm) {
        const resp = id;
        const message = resp
          ? "El usuario se ha eliminado correctamente"
          : "Ocurrió un error con el usuario";
        const type = resp ? "success" : "error";
        this.$root.$alert(message, type);
      }
    },


    async getUsuarios(){
      const response = await UserService.getAll()
      console.log('response', this);
      return response;
    },
    
    closeDialog(status) {
      this.showDialog = status;
    },
  },
};
</script>

<style scoped>
.container {
  text-align: start !important;
}
</style>
